// extracted by mini-css-extract-plugin
export default {"comfirmModal":"TripList_comfirmModal__UUbi0"};